export default __webpack_public_path__ + "static/translator-19a6342da5cf7539b2461c582d6ad993.jpg";